(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/get-order.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/get-order.js');
"use strict";

const {
  jupiter
} = svs.core;
const logger = svs.ticketsOrderHome.utils.logger;
const getOrder = async referenceId => {
  const path = "/ticket/1/mailbox/orders/".concat(referenceId);
  return await jupiter.callAsync({
    method: 'GET',
    path,
    data: {}
  });
};

const getOrderItemsAsync = async referenceId => {
  try {
    const {
      response
    } = await svs.ticketsOrderHome.services.getOrder(referenceId);
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error when fetching mailbox order', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      orderItems: (response === null || response === void 0 ? void 0 : response.orderItems) || [],
      status: response === null || response === void 0 ? void 0 : response.status,
      giftAddress: response === null || response === void 0 ? void 0 : response.giftAddress,
      orderType: response === null || response === void 0 ? void 0 : response.orderType
    };
  } catch (err) {
    logger.warn('Error catched when fetching mailbox order', err);
    return {
      error: err,
      orderItems: [],
      status: ''
    };
  }
};
setGlobal('svs.ticketsOrderHome.services.getOrder', getOrder);
setGlobal('svs.ticketsOrderHome.services.getOrderItemsAsync', getOrderItemsAsync);

 })(window);